<div class="important-text">
  <span
    [class]="size"
  ><strong>{{text}}</strong></span>
</div>
